// extracted by mini-css-extract-plugin
module.exports = {"footer":"MutateMid_footer__3N-oA","legacyBtn":"MutateMid_legacyBtn__2KGym"};